import { render } from "./InstagramHackView.vue?vue&type=template&id=0c5bc50b&scoped=true"
import script from "./InstagramHackView.vue?vue&type=script&lang=js"
export * from "./InstagramHackView.vue?vue&type=script&lang=js"

import "./InstagramHackView.vue?vue&type=style&index=0&id=0c5bc50b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c5bc50b"

export default script